import dayjs from "dayjs";
import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useGetMonthlyWorkDaysStaffDhashboardQuery } from "../../../../Api/attoDeskApi";

interface IMonthlyWorkDays {
  empid: number;
  month: string; // Example: "2025-08"
  days_worked: number;
}

interface IProps {
  staffId: string;
}

const MonthlyWorkedDaysBarChart: React.FC<IProps> = ({ staffId }) => {
  const theme = useTheme();

  const { data: apiResponse } = useGetMonthlyWorkDaysStaffDhashboardQuery({
    empid: staffId,
  });

  const payrollData = useMemo(() => {
    return (apiResponse?.data as IMonthlyWorkDays[]) || [];
  }, [apiResponse]);

  // Convert "YYYY-MM" → "Aug", "Sep", ...
  const categories = payrollData.map((item) =>
    dayjs(item.month + "-01").format("MMM")
  );

  const values = payrollData.map((item) => item.days_worked);

  const options: Highcharts.Options = {
    chart: {
      type: "column",
      backgroundColor: theme.palette.cardAdd.bgColor,
    },
    title: {
      text: "Monthly Worked Days",
      style: {
        fontSize: "0.9375rem",
        color: theme.palette.heading.headingColor,
      },
    },
    xAxis: {
      categories,
      title: {
        text: "Month",
        style: {
          fontSize: "0.75rem",
          color: theme.palette.heading.headingColor,
        },
      },
      labels: {
        style: {
          fontSize: "0.75rem",
          color: theme.palette.heading.headingColor,
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Days",
        style: {
          fontSize: "0.75rem",
          color: theme.palette.heading.headingColor,
        },
      },
      labels: {
        style: {
          fontSize: "0.75rem",
          color: theme.palette.heading.headingColor,
        },
      },
    },
    legend: { enabled: false },
    series: [
      {
        type: "column",
        name: "Days Worked",
        data: values,
        color: Highcharts.color(theme.palette.primary.main).get() || "#7cb5ec",
      },
    ],
  };

  return (
    <Box>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};

export default MonthlyWorkedDaysBarChart;
